// src/core/utils/theme.js

// Charger un fichier CSS de thème
export function loadThemeCss(themeName, isAdmin = false) {
    if (!themeName || typeof themeName !== 'string') {
      themeName = 'theme1';
    }
  
    const existing = document.getElementById(isAdmin ? 'admin-style' : 'theme-style');
    if (existing) existing.remove();
  
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = isAdmin ? 'admin-style' : 'theme-style';
    link.href = isAdmin ? '/styles/admin.css' : `/styles/${themeName}.css`;
  
    document.head.appendChild(link);
  }
  
  // Appliquer les couleurs personnalisées du thème6
  export function applyCustomTheme6Colors(colors) {
    if (!colors) return;
  
    const root = document.documentElement;
    for (const [key, value] of Object.entries(colors)) {
      const cssVar = `--${key.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}`;
      root.style.setProperty(cssVar, value);
    }
  }
  